import styled from 'styled-components';
import { ButtonBase } from './ButtonBase';

export const PrimaryButton = styled(ButtonBase)`
    background: #0150B5;
    color: #fff;
    border-radius: 4px;
`